module.exports = __webpack_public_path__ + "static/media/pizzaAmigoSecreto.2f81a75d.png";